import { decimalPlaceDropdownOption, proposalByDropdownOption, roundMethodDropdownOption } from "presentation/constant/DropDownOptions/StaticDropdownOptions";
import { ProposalCopyingForRecalConstant } from "presentation/constant/ProposalCopyingForRecal/ProposalCopyingForRecalConstant";
import { useProposalCopyingForRecalVM } from "presentation/hook/ProposalCopyingForRecal/useProposalCopyingForRecalVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useProposalCopyingForRecalTracked } from "presentation/store/ProposalCopyingForRecal/ProposalCopyingForRecalProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DatePickerComponent from "presentation/view/components/DatePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { memo, useCallback, useMemo } from "react";
import { FieldType, IconButton, IFieldValue } from "veronica-ui-component/dist/component/core";
import { SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";


const UpdatePercentageAndProposalNoForRecalPanel: React.FC = () => {

    const SCREEN_CONSTANT = ProposalCopyingForRecalConstant.Table;
    const [proposalCopyingForRecalState] = useProposalCopyingForRecalTracked();
    const proposalCopyingForRecalVM = useProposalCopyingForRecalVM();
    const messageBarVM = useMessageBarVM();
    const { masterState, isEditPercentage, isEditProposalNo, isEditNewProposalNo, copyToEditPercentage, copyToEditProposalNo, copyToEditNewProposal } = proposalCopyingForRecalState;
    const { isSaveClicked, allFormState } = masterState;
    const onNumberFieldChange = useCallback((e: any, fieldName: string, fieldValue: any) => {
        proposalCopyingForRecalVM.onCopyPercentageFieldChange(fieldName, fieldValue);
    }, [proposalCopyingForRecalVM]);

    const handClose = useCallback(() => {
        proposalCopyingForRecalVM.onTariffItemCopyEditCloseClick();
    }, [proposalCopyingForRecalVM]);

    const handSave = useCallback(() => {
        if (isEditPercentage) {
            proposalCopyingForRecalVM.onSaveClicked();
            proposalCopyingForRecalVM.onCopyEditPercentageSaveClick(copyToEditPercentage);
        }
        if (isEditProposalNo) {
            proposalCopyingForRecalVM.onSaveClicked();
            proposalCopyingForRecalVM.onCopyEditProposalNoSaveClick(copyToEditProposalNo);
        }
        if (isEditNewProposalNo) {
            // if (!copyToEditNewProposal.effectiveDate) {
            //     messageBarVM.showError("Effective Date is mandatory.");
            //     return;
            // }
            // if (!copyToEditNewProposal.expiryDate) {
            //     messageBarVM.showError("Expiry Date is mandatory.");
            //     return;
            // }
            if (copyToEditNewProposal.effectiveDate && copyToEditNewProposal.expiryDate && new Date(copyToEditNewProposal.expiryDate) < new Date(copyToEditNewProposal.effectiveDate)) {
                messageBarVM.showError("The Expiry Date must be greater than the Effective Date.");
                return;
            }
            // if (!copyToEditNewProposal.currencyCode) {
            //     messageBarVM.showError("Currency is mandatory.");
            //     return;
            // }
            // if (!copyToEditNewProposal.proposalCreatedByMethod) {
            //     messageBarVM.showError("Proposal By is mandatory.");
            //     return;
            // }

            proposalCopyingForRecalVM.onSaveClicked();
            proposalCopyingForRecalVM.onCopyEditNewProposalNoSaveClick(copyToEditNewProposal);
        }
    }, [isEditPercentage, isEditProposalNo, isEditNewProposalNo, proposalCopyingForRecalVM, copyToEditPercentage, copyToEditProposalNo, copyToEditNewProposal, messageBarVM]);

    const memoTariffType = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "30px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={false}
                readOnlyValue={copyToEditPercentage.tariffType || ''}
                fieldValue={copyToEditPercentage.tariffType}
                fieldLabel={SCREEN_CONSTANT.TARIFF_TYPE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'tariffType'}
                maxLength={60}
                options={proposalCopyingForRecalState.dynamicOptions.tariffTypeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onCopyPercentageFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.TARIFF_TYPE, allFormState, copyToEditPercentage.tariffType, isSaveClicked, proposalCopyingForRecalState.dynamicOptions.tariffTypeDropdownOptions, proposalCopyingForRecalVM])

    const memoChargePercentage = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "30px", marginLeft: "20px" }}>
            <NumberInputComponent
                label={SCREEN_CONSTANT.CHARGE_PERCENTAGE}
                maxLength={10}
                fieldName={"chargePercentage"}
                value={copyToEditPercentage.chargePercentage ?? ''}
                errorMessage={allFormState ? allFormState["chargePercentage"] ?? "" : ""}
                disabled={false}
                decimalPlaces={2}
                onChange={(e: any, fieldKey: string, fieldValue: any) => onNumberFieldChange(e, fieldKey, fieldValue)}
            />
        </div>
        , [SCREEN_CONSTANT.CHARGE_PERCENTAGE, allFormState, copyToEditPercentage.chargePercentage, onNumberFieldChange])

    const memoRoundMethod = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "30px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={copyToEditPercentage.roundMethod || ''}
                fieldValue={copyToEditPercentage.roundMethod}
                fieldLabel={SCREEN_CONSTANT.ROUND_METHOD}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'roundMethod'}
                maxLength={60}
                options={roundMethodDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onCopyPercentageFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.ROUND_METHOD, allFormState, copyToEditPercentage.roundMethod, isSaveClicked, proposalCopyingForRecalVM])

    const memoDecimalPlace = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "180px", marginBottom: "30px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={copyToEditPercentage.decimalPlace || ''}
                fieldValue={copyToEditPercentage.decimalPlace}
                fieldLabel={SCREEN_CONSTANT.DECIMAL_PLACE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'decimalPlace'}
                maxLength={60}
                options={decimalPlaceDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onCopyPercentageFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.DECIMAL_PLACE, allFormState, copyToEditPercentage.decimalPlace, isSaveClicked, proposalCopyingForRecalVM])


    const memoCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "30px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={copyToEditProposalNo.companyCode || ''}
                fieldValue={copyToEditProposalNo?.companyCode}
                fieldLabel={SCREEN_CONSTANT.COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyCode'}
                maxLength={60}
                isLimitOptions={true}
                options={proposalCopyingForRecalState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onCopyProposalNoFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.COMPANY_CODE, allFormState, copyToEditProposalNo.companyCode, isSaveClicked, proposalCopyingForRecalState.dynamicOptions.companyCodeDropdownOptions, proposalCopyingForRecalVM])

    const memoProposalNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "30px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={copyToEditProposalNo.proposalNo || ''}
                fieldValue={copyToEditProposalNo.proposalNo}
                fieldLabel={SCREEN_CONSTANT.PROPOSAL_NO}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'proposalNo'}
                maxLength={60}
                requiredFieldList={[]}
                options={proposalCopyingForRecalState.dynamicOptions.companyCodeProposalNoDropdownOptions}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onCopyProposalNoFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.PROPOSAL_NO, allFormState, copyToEditProposalNo.proposalNo, isSaveClicked, proposalCopyingForRecalState.dynamicOptions.companyCodeProposalNoDropdownOptions, proposalCopyingForRecalVM])

    const memoNewCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "30px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={true}
                isShowOptional={true}
                readOnlyValue={copyToEditNewProposal?.companyCode || ''}
                fieldValue={copyToEditNewProposal?.companyCode}
                fieldLabel={SCREEN_CONSTANT.COMPANY_CODE}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyCode'}
                maxLength={60}
                isLimitOptions={true}
                options={proposalCopyingForRecalState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onCopyNewProposalNoFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.COMPANY_CODE, allFormState, copyToEditNewProposal?.companyCode, isSaveClicked, proposalCopyingForRecalState.dynamicOptions.companyCodeDropdownOptions, proposalCopyingForRecalVM])

    const memoEffectiveDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "30px", marginLeft: "20px" }}>
            <DatePickerComponent
                disabled={false}
                label={SCREEN_CONSTANT.EFFECTIVE_DATE}
                width="185px"
                date={copyToEditNewProposal.effectiveDate}
                fieldName="effectiveDate"
                errorMessage={allFormState ? allFormState["effectiveDate"] ?? "" : ""}
                onDateChange={proposalCopyingForRecalVM.onCopyNewProposalNoFieldChange} />
        </div>
        , [SCREEN_CONSTANT.EFFECTIVE_DATE, allFormState, copyToEditNewProposal.effectiveDate, proposalCopyingForRecalVM.onCopyNewProposalNoFieldChange])

    const memoExpiryDate = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "30px", marginLeft: "20px" }}>
            <DatePickerComponent
                disabled={false}
                label={SCREEN_CONSTANT.EXPIRY_DATE}
                width="185px"
                date={copyToEditNewProposal.expiryDate}
                fieldName="expiryDate"
                errorMessage={allFormState ? allFormState["expiryDate"] ?? "" : ""}
                onDateChange={proposalCopyingForRecalVM.onCopyNewProposalNoFieldChange} />
        </div>
        , [SCREEN_CONSTANT.EXPIRY_DATE, allFormState, copyToEditNewProposal.expiryDate, proposalCopyingForRecalVM.onCopyNewProposalNoFieldChange])

    const memoCurrency = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "30px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={copyToEditNewProposal?.currencyCode || ''}
                fieldValue={copyToEditNewProposal?.currencyCode}
                fieldLabel={SCREEN_CONSTANT.CURRENCY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'currencyCode'}
                maxLength={60}
                options={proposalCopyingForRecalState.dynamicOptions.currencyCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onCopyNewProposalNoFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.CURRENCY, allFormState, copyToEditNewProposal?.currencyCode, isSaveClicked, proposalCopyingForRecalState.dynamicOptions.currencyCodeDropdownOptions, proposalCopyingForRecalVM])

    const memoProposalBy = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "30px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={copyToEditNewProposal.proposalCreatedByMethod || ''}
                fieldValue={copyToEditNewProposal?.proposalCreatedByMethod}
                fieldLabel={SCREEN_CONSTANT.PROPOSAL_BY}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'proposalCreatedByMethod'}
                maxLength={60}
                options={proposalByDropdownOption}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onCopyNewProposalNoFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.PROPOSAL_BY, allFormState, copyToEditNewProposal.proposalCreatedByMethod, isSaveClicked, proposalCopyingForRecalVM])

    const memoRemarks = useMemo(() =>
        <div className='im-flex-row-item' id="std-proposal-edit-remarks" style={{ width: "420px", marginBottom: "30px", marginLeft: "20px" }} >
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={copyToEditNewProposal?.remarks || ''}
                fieldValue={copyToEditNewProposal.remarks}
                fieldLabel={SCREEN_CONSTANT.REMARKS}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'remarks'}
                maxLength={100}
                rows={1}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onCopyNewProposalNoFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)}
            />
        </div>
        , [SCREEN_CONSTANT.REMARKS, allFormState, copyToEditNewProposal.remarks, isSaveClicked, proposalCopyingForRecalVM])

    const memoOperatingTml = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "185px", marginBottom: "30px", marginLeft: "20px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={copyToEditNewProposal.operatingTml || ''}
                fieldValue={copyToEditNewProposal.operatingTml}
                fieldLabel={SCREEN_CONSTANT.OPERATING_TML}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'operatingTml'}
                maxLength={60}
                options={proposalCopyingForRecalState.dynamicOptions.operatingTmlDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    proposalCopyingForRecalVM.onCopyNewProposalNoFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
        </div>
        , [SCREEN_CONSTANT.OPERATING_TML, allFormState, copyToEditNewProposal.operatingTml, isSaveClicked, proposalCopyingForRecalState.dynamicOptions.operatingTmlDropdownOptions, proposalCopyingForRecalVM])


    return <>
        <div className={'flex-row'} style={{ overflow: "visible", zIndex: "100" }}>
            <div className={'flex-row-item flex-row-item-full-width'} >
                <Sidebarheader>
                    <SidebarTitle></SidebarTitle>
                    <SidebarActionCross>
                        <IconButton
                            fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={handClose} />
                        <IconButton
                            fileName="Icon-tick" size="medium" toolTipText='Save' toolTipArrow={false} onClick={handSave} />
                    </SidebarActionCross>
                </Sidebarheader>
            </div>


            {isEditPercentage && <>
                <CriteriaItemContainer>
                    {memoTariffType}
                    {memoChargePercentage}
                    {/* </CriteriaItemContainer>

                <CriteriaItemContainer> */}
                    {memoRoundMethod}
                    {memoDecimalPlace}
                </CriteriaItemContainer></>}

            {isEditProposalNo && <>
                <CriteriaItemContainer>
                    {memoCompanyCode}
                    {memoProposalNo}
                </CriteriaItemContainer></>}

            {isEditNewProposalNo && <>
                <CriteriaItemContainer>
                    {memoNewCompanyCode}
                    {memoEffectiveDate}
                    {memoExpiryDate}
                    {memoCurrency}
                    {memoProposalBy}
                    {memoOperatingTml}
                    {memoRemarks}
                </CriteriaItemContainer></>}
        </div>
    </>;
}

export default memo(UpdatePercentageAndProposalNoForRecalPanel);
